module.exports = __webpack_public_path__ + "img/vista_eye_yellow.6182c32d.gif";